const pricing_faq_data = [
  {
    id: 1,
    question: 'How is the payment processed?',
    answer: 'The payment is done through Stripe, we don\'t store anything related with the payment.\n',
  },
  {
    id: 2,
    question: 'Can I cancel my subscription?',
    answer: 'Yes, you can cancel anytime, and you can also ask for a refund if you do not enjoy the experience. No questions, just send us an email.',
  },
  {
    id: 3,
    question: 'Why do I have to pay?',
    answer: 'We believe that paying for being a member is a way of commitment and it helps to maintain the operational costs for organising the community.',
  },
  {
    id: 4,
    question: 'Are the books included with the membership?',
    answer: 'No, the membership is to get access to the community. The books are not included, you have to buy them separately.',
  }
];

export {pricing_faq_data};
